import { Component, EventEmitter, OnInit, Output } from "@angular/core";

import { GameItem } from "src/app/models/GameItem.model";

const ITEMS = [
  { id: 1, image: "assets/images/items/item_1.png" },
  { id: 2, image: "assets/images/items/item_2.png" },
  { id: 3, image: "assets/images/items/item_3.png" },
  { id: 4, image: "assets/images/items/item_4.png" },
  { id: 5, image: "assets/images/items/item_5.png" },
  { id: 6, image: "assets/images/items/item_6.png" },
  { id: 7, image: "assets/images/items/item_7.png" },
  { id: 8, image: "assets/images/items/item_8.png" },
  { id: 9, image: "assets/images/items/item_9.png" },
  { id: 10, image: "assets/images/items/item_10.png" },
  { id: 11, image: "assets/images/items/item_11.png" },
  { id: 12, image: "assets/images/items/item_12.png" },
  { id: 13, image: "assets/images/items/item_13.png" },
];

const MAX_SCORE = 50;

@Component({
  selector: "app-memory-game",
  templateUrl: "./memory-game.component.html",
  styleUrls: ["./memory-game.component.scss"],
})
export class MemoryGameComponent implements OnInit {
  @Output() onScore = new EventEmitter<number>();
  @Output() onWrong = new EventEmitter<void>();
  @Output() onTimer = new EventEmitter<number>();
  @Output() onGameEnd = new EventEmitter<void>();

  items: GameItem[] = [];
  selectedItem: GameItem | null = null;
  timer: any = null;
  timerWrong: any = null;
  timerEnd: any = null;
  gameClock: any;
  gameTime: number = 60;
  score: number = 0;

  private background: HTMLAudioElement;
  private effect: HTMLAudioElement;

  constructor() {
    this.background = new Audio("assets/audio/theme.mp3");
    this.background.loop = true;
    this.background.volume = 0.4; // volumen más bajo para fondo

    this.effect = new Audio();
    this.effect.volume = 1; // volumen normal para efectos
  }

  playBackground() {
    this.background.play().catch((err) => {
      console.warn("Background audio no pudo iniciar:", err);
    });
  }

  stopBackground() {
    this.background.pause();
    this.background.currentTime = 0;
  }

  playEffect(file: string = "score.mp3") {
    this.effect.src = `assets/audio/${file}`;
    this.effect.currentTime = 0;
    this.effect.play().catch((err) => {
      console.warn("Effect audio no pudo iniciar:", err);
    });
  }

  ngOnInit() {
    this.items = this.generateItems();

    this.startGame();
  }

  ngOnDestroy(): void {
    if (this.timer) clearTimeout(this.timer);
    if (this.gameClock) clearInterval(this.gameClock);
    if (this.timerWrong) clearTimeout(this.timerWrong);
    if (this.timerEnd) clearTimeout(this.timerEnd);

    this.stopBackground();
  }

  startGame() {
    this.playBackground();

    this.gameClock = setInterval(() => {
      this.gameTime--;
      this.onTimer.emit(this.gameTime);

      if (this.gameTime === 0) {
        this.endGame();
      }
    }, 1000);
  }

  endGame() {
    clearInterval(this.gameClock);

    if (this.timer) clearTimeout(this.timer);
    if (this.timerWrong) clearTimeout(this.timerWrong);
    if (this.timerEnd) clearTimeout(this.timerEnd);

    this.onGameEnd.emit();
  }

  handleMatch(item: GameItem) {
    if (this.timer || this.timerWrong) return;

    if (item.state === "hidden") {
      item.state = "visible";

      if (this.selectedItem) {
        if (this.selectedItem.image === item.image) {
          item.state = "matched";
          this.selectedItem.state = "matched";
          this.selectedItem = null;

          this.playEffect();
          this.score += 10;
          this.onScore.emit(this.score);

          this.checkScore();
        } else {
          this.reset(item);
        }
      } else {
        this.selectedItem = item;
      }
    }
  }

  checkScore() {
    if (this.score === MAX_SCORE) {
      this.timerEnd = setTimeout(() => {
        this.endGame();
      }, 750);
    }
  }

  reset(item: GameItem) {
    if (this.timer) clearTimeout(this.timer);
    if (this.timerWrong) clearTimeout(this.timerWrong);

    this.playEffect("wrong.mp3");

    this.onWrong.emit();

    item.state = "wrong";
    this.selectedItem.state = "wrong";

    this.timer = setTimeout(() => {
      item.state = "hidden";
      this.selectedItem.state = "hidden";
      this.selectedItem = null;
      this.timer = null;
    }, 900);
  }

  generateItems(): GameItem[] {
    const duplicated: GameItem[] = [];

    const gameItems = ITEMS.map((item) => Object.assign({}, item));
    const randomItems = this.getRandomItems(5);

    randomItems.forEach((item) => {
      const cloneItem = Object.assign({}, item);

      const index = this.getRandomId(gameItems.length, cloneItem.id);
      const matchedItem = Object.assign({}, gameItems[index]);

      duplicated.push({
        id: cloneItem.id,
        image: cloneItem.image,
        state: "hidden",
      });

      duplicated.push({
        id: matchedItem.id,
        image: cloneItem.image,
        state: "hidden",
      });

      gameItems.splice(index, 1);
    });

    for (let i = duplicated.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [duplicated[i], duplicated[j]] = [duplicated[j], duplicated[i]];
    }

    return duplicated;
  }

  getRandomItems(nItems: number) {
    const itemsCopy = ITEMS.map((item) => Object.assign({}, item));

    for (let i = itemsCopy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [itemsCopy[i], itemsCopy[j]] = [itemsCopy[j], itemsCopy[i]];
    }

    return itemsCopy.slice(0, nItems);
  }

  getRandomId(arrLength: number, excludeIndex: number): number {
    let index = -1;

    do {
      index = Math.floor(Math.random() * arrLength);
    } while (index === excludeIndex);

    return index;
  }
}
